import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from '@material-ui/core';
import { withContext } from 'common/helpers/context';
import { addTeam } from './actions/addTeam';

const AddTeamModal = (props) => {
  const { userId, open, handleClose } = props;

  const [teamName, setTeamName] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleAddTeam = async () => {
    setIsLoading(true);
    await props.addTeam(userId, teamName);
    setIsLoading(false);
    handleClose();
  };

  const handleOnChange = (event) => {
    setTeamName(event.target.value);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      fullWidth
      maxWidth="xs"
    >
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Team Name"
          type="email"
          value={teamName}
          onChange={handleOnChange}
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" variant="contained" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          color="primary"
          variant="contained"
          disabled={teamName.length === 0}
          onClick={handleAddTeam}
        >
          {isLoading ? <CircularProgress /> : 'Add'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

AddTeamModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  addTeam: PropTypes.func.isRequired,
};

export default connect(null, {
  addTeam,
})(withContext(AddTeamModal));
